import React, { useEffect, useState } from "react";
import api from "../../api/axios";

const styles = {
  container: {
    padding: "20px",
    fontFamily: "Arial, sans-serif",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "15px",
  },
  searchBox: {
    display: "flex",
    gap: "5px",
  },
  input: {
    padding: "6px",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  thtd: {
    borderBottom: "1px solid #ddd",
    padding: "10px",
    textAlign: "left",
  },
  badge: {
    padding: "4px 10px",
    borderRadius: "12px",
    fontSize: "12px",
    color: "#fff",
    display: "inline-block",
  },
  badgeSuccess: {
    background: "#28a745",
  },
  badgeDanger: {
    background: "#dc3545",
  },
  badgeInfo: {
    background: "#17a2b8",
  },
  btn: {
    padding: "6px 10px",
    cursor: "pointer",
    background: "transparent",
    borderRadius: "4px",
    marginRight: "5px",
  },
  btnPrimary: {
    background: "#007bff",
    color: "#fff",
    border: "none",
  },
  btnOutlinePrimary: {
    border: "1px solid #007bff",
    color: "#007bff",
  },
  btnOutlineDanger: {
    border: "1px solid #dc3545",
    color: "#dc3545",
  },
};
const modalStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.4)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modal: {
    width: "900px",
    background: "#fff",
    borderRadius: "8px",
    padding: "20px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
  },
  title: {
    fontSize: "24px",
    marginBottom: "20px",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "20px",
  },
  label: {
    fontWeight: "bold",
    marginBottom: "6px",
    display: "block",
  },
  input: {
    width: "100%",
    padding: "10px",
    borderRadius: "5px",
    border: "1px solid #ccc",
  },
  footer: {
    marginTop: "25px",
    display: "flex",
    gap: "10px",
  },
  note: {
    fontSize: "12px",
    marginTop: "6px",
    color: "#555",
  },
};

const SlidersSection = () => {
  const [sliders, setSliders] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);

  const [formData, setFormData] = useState({
      title: "",
      sub_title: "",
      type: "image",
      position: "",
      is_active: true,
      file: null,
    });

  const resetForm = () => {
  setFormData({
    title: "",
    sub_title: "",
    type: "image",
    position: "",
    is_active: true,
    file: null,
  });
};

  useEffect(() => {
    fetchSliders();
  }, []);

  const fetchSliders = async (query = "") => {
    try {
      setLoading(true);
      const res = await api.get(
        `companyblog/admin/sliders/?search=${query}`
      );
      setSliders(res.data);
    } catch (err) {
      console.error("Failed to fetch sliders", err);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    fetchSliders(search);
  };

const handleDelete = async (id) => {
  if (!window.confirm("Are you sure you want to delete this slider?")) return;

  try {
    await api.delete(`companyblog/admin/sliders/delete/${id}/`);
    fetchSliders();
  } catch (err) {
    console.error("Delete failed", err);
  }
};

const handleCreateSlider = async () => {
  if (!formData.title.trim()) {
    alert("Title is required");
    return;
  }

  if (!formData.position || Number(formData.position) <= 0) {
    alert("Position must be a positive number");
    return;
  }

  if (!formData.file) {
    alert("Image / Video file is required");
    return;
  }

  const data = new FormData();
  data.append("title", formData.title);
  data.append("sub_title", formData.sub_title);
  data.append("type", formData.type);
  data.append("position", Number(formData.position));
  data.append("is_active", formData.is_active);

  if (formData.type === "image") {
    data.append("image", formData.file);
  } else {
    data.append("video", formData.file);
  }

  try {
    await api.post(
      "companyblog/admin/sliders/create/",
      data
    );

    setShowModal(false);
    fetchSliders();
    resetForm();
  } catch (error) {
  console.error("❌ BACKEND ERROR:", error.response?.data);
  alert(JSON.stringify(error.response?.data));
}
};


  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <form style={styles.searchBox} onSubmit={handleSearch}>
          <input
            style={styles.input}
            type="text"
            placeholder="Slider"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <button style={{ ...styles.btn, ...styles.btnPrimary }} type="submit">
            Search
          </button>
        </form>

        <button style={{ ...styles.btn, ...styles.btnPrimary }}
        onClick={() => setShowModal(true)}
        >
          + New Slider
        </button>
      </div>

      {/* Table */}
      <table style={styles.table}>
        <thead>
          <tr>
            {[
              "S.No.",
              "Image / Video",
              "Title",
              "Sub-title",
              "Type",
              "Position",
              "Status",
              "Action",
            ].map((h) => (
              <th key={h} style={styles.thtd}>
                {h}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {loading ? (
            <tr>
              <td colSpan="8" style={{ ...styles.thtd, textAlign: "center" }}>
                Loading...
              </td>
            </tr>
          ) : sliders.length === 0 ? (
            <tr>
              <td colSpan="8" style={{ ...styles.thtd, textAlign: "center" }}>
                No sliders found
              </td>
            </tr>
          ) : (
            sliders.map((slider, index) => (
              <tr key={slider.id}>
                <td style={styles.thtd}>{index + 1}</td>

                <td style={styles.thtd}>
                  {slider.type === "image" && slider.image ? (
                    <img src={slider.image} alt="slider" width="80" />
                  ) : slider.type === "video" ? (
                    "Video"
                  ) : (
                    "-"
                  )}
                </td>

                <td style={styles.thtd}>{slider.title || "-"}</td>
                <td style={styles.thtd}>{slider.sub_title || "-"}</td>

                <td style={styles.thtd}>
                  <span style={{ ...styles.badge, ...styles.badgeInfo }}>
                    {slider.type.toUpperCase()}
                  </span>
                </td>

                <td style={styles.thtd}>{slider.position}</td>

                <td style={styles.thtd}>
                  {slider.is_active ? (
                    <span
                      style={{ ...styles.badge, ...styles.badgeSuccess }}
                    >
                      Active
                    </span>
                  ) : (
                    <span
                      style={{ ...styles.badge, ...styles.badgeDanger }}
                    >
                      Inactive
                    </span>
                  )}
                </td>

                <td style={styles.thtd}>
                  <button
                    style={{ ...styles.btn, ...styles.btnOutlineDanger }}
                    onClick={() => handleDelete(slider.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
      {showModal && (
  <div style={modalStyles.overlay}>
    <div style={modalStyles.modal}>
      <h2 style={modalStyles.title}>Create Slider</h2>

      <div style={modalStyles.grid}>
        {/* Title */}
        <div>
          <label style={modalStyles.label}>Title</label>
          <input
            style={modalStyles.input}
            placeholder="Slider Title"
            value={formData.title}
            onChange={(e) =>
              setFormData({ ...formData, title: e.target.value })
            }
          />
        </div>

        {/* Sub Title */}
        <div>
          <label style={modalStyles.label}>Sub Title</label>
          <input
            style={modalStyles.input}
            placeholder="Slider Sub-title"
            value={formData.sub_title}
            onChange={(e) =>
              setFormData({ ...formData, sub_title: e.target.value })
            }
          />
        </div>

        {/* Type */}
        <div>
          <label style={modalStyles.label}>Type *</label>
          <select
            style={modalStyles.input}
            value={formData.type}
            onChange={(e) =>
              setFormData({ ...formData, type: e.target.value })
            }
          >
            <option value="image">Image</option>
            <option value="video">Video</option>
          </select>
        </div>

        {/* Position */}
        <div>
          <label style={modalStyles.label}>Position *</label>
          <input
            style={modalStyles.input}
            type="number"
            value={formData.position}
            onChange={(e) =>
              setFormData({ ...formData, position: e.target.value })
            }
          />
        </div>

        {/* File */}
        <div>
          <label style={modalStyles.label}>Image / Video *</label>
          <input
            type="file"
            accept={formData.type === "image" ? "image/*" : "video/*"}
            onChange={(e) =>
              setFormData({ ...formData, file: e.target.files[0] })
            }
          />
          <div style={modalStyles.note}>
            Required dimension is <b>2500 × 1250 px</b>
          </div>
        </div>

        {/* Status */}
        <div>
          <label style={modalStyles.label}>Is Status Active</label>
          <input
            type="checkbox"
            checked={formData.is_active}
            onChange={(e) =>
              setFormData({ ...formData, is_active: e.target.checked })
            }
          />
        </div>
      </div>

      {/* Footer */}
      <div style={modalStyles.footer}>
        <button style={{ ...styles.btn, ...styles.btnPrimary }}
        onClick={handleCreateSlider}
        >
          Save
        </button>
        <button
          style={styles.btn}
          onClick={() => setShowModal(false)}
        >
          Close
        </button>
      </div>
    </div>
  </div>
)}

    </div>

  );
};

export default SlidersSection;
